import React from 'react'
import Image from 'next/image'

import FeaturesFooter from '@/components/sections/FeaturesFooter'
import { Layout, Section } from '@/components/layout'
import { Link } from '@/components/common'
import TryFreeCta from '@/components/TryFreeCta'
import routes from '@/routes'
import quickbooksIntegrationImg from '@/assets/integrate-seamlessly-with-quickbooks/quickbooks-integration.png'
import headerLogoImg from '@/assets/header-logo.svg'

const pageId = 'integrateSeamlesslyWithQuickbooks'

export default function IntegrateSeamlesslyWithQuickbooks() {
  return (
    <Layout.Content>
      <Section bgBlob textCenter>
        <Link to={routes.index}>
          <Image alt="Neat" src={headerLogoImg} width={110} />
        </Link>
        <h1>Connect Seamlessly With QuickBooks</h1>
        <TryFreeCta />
        <Image alt="" src={quickbooksIntegrationImg} style={{ height: 'auto' }} />
      </Section>
      <Section>
        <div className="max-w-700 policy-text">
          <h3>Eliminate Data Entry With Neat and QuickBooks</h3>
          <p>Using Neat with QuickBooks Online simplifies accounting by reducing data entry and automatically organizing expenses.</p>
          <ul>
            <li>Review and send all expense-related data directly over to QuickBooks. Images of receipts and invoices are automatically attached.</li>
            <li>Sign in to QuickBooks from the Neat app to connect.</li>
            <li>Map expenses once to match your QuickBooks preferences and future data will map automatically.</li>
          </ul>
          <p><strong>Visit our support center for more information on integrating <Link external openTab to="https://support.neat.com/qbo/integrating-quick-books-online-with-neat">QuickBooks Online</Link>.</strong></p>
        </div>
      </Section>
      <FeaturesFooter noPaddingTop />
    </Layout.Content>
  )
}

IntegrateSeamlesslyWithQuickbooks.layoutProps = {
  pageId,
  showHeader: false,
}
